// extracted by mini-css-extract-plugin
export default {"wrapper":"About_wrapper__7FEaU","header":"About_header__Jum2B","goBack":"About_goBack__81MkG","container":"About_container__92mvf"};